import { useEffect } from "react";

export const useInfiniteScroll = (
  containerRef,
  sentinelRef,
  callback,
  hasMore,
  loading,
  rootMargin = "0px 0px 80px 0px"
) => {
  useEffect(() => {
    const el = containerRef.current;
    const sentinel = sentinelRef.current;
    if (!el || !sentinel) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !loading && hasMore) {
          console.log("Sentinel visible, calling callback...");
          callback();
        }
      },
      {
        root: el,          // container scrollable
        rootMargin,
        threshold: 1.0     // trigger saat sentinel benar-benar terlihat penuh
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [containerRef, sentinelRef, callback, hasMore, loading]);
};

export const useInfiniteScrollWindow = (
  callback,
  hasMore,
  loading,
  threshold = 50
) => {
  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
      // Debug log
      console.log("scrollTop:", scrollTop, "clientHeight:", clientHeight, "scrollHeight:", scrollHeight);

      const bottomReached = scrollTop + clientHeight >= scrollHeight - threshold;

      if (bottomReached && !loading && hasMore) {
        console.log("Bottom reached, calling callback...");
        callback();
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup otomatis saat komponen unmount / pindah page
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [callback, hasMore, loading, threshold]);
};